import { parsePlanAndAnswer } from '@/utils/aidaStreamParse';
import { buildConversationId, createChatSessionId, resolveChatApiKey } from '@/utils/chatConversation';

export async function askAidaToolRecommendation({
  prompt,
  authorization,
  userSub,
  signal,
}: {
  prompt: string;
  authorization: string;
  userSub?: string;
  signal?: AbortSignal;
}): Promise<string> {
  const apiKey = await resolveChatApiKey(userSub);
  if (!apiKey) {
    throw new Error('AIDA API key is not available');
  }
  if (!authorization) {
    throw new Error('You need to be signed in to ask AIDA');
  }

  const chatSessionId = createChatSessionId();
  const headers: Record<string, string> = {
    Authorization: `Bearer ${authorization}`,
    'x-api-key': apiKey,
    'x-conversation-id': buildConversationId(apiKey, chatSessionId),
  };

  const url = `${process.env.REACT_APP_URL_CHAT_API}get?msg=${encodeURIComponent(prompt)}`;
  const response = await fetch(url, {
    method: 'GET',
    headers,
    credentials: 'include',
    signal,
  });

  if (!response.ok) {
    throw new Error('AIDA could not answer right now. Showing a local recommendation instead.');
  }
  if (!response.body) {
    throw new Error('Empty response from AIDA');
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let rawText = '';
  let done = false;

  while (!done) {
    const { value, done: chunkDone } = await reader.read();
    done = chunkDone;
    if (value) rawText += decoder.decode(value, { stream: true });
  }

  const { answer } = parsePlanAndAnswer(rawText);
  return (answer || rawText).trim();
}
